import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { OLD_VALUES_FORM_ID } from './constants';
import { OldValuesStepFooter as messages } from './messages';

export const OldValuesStepFooter: VFC = () => {
  return (
    <Button key="submit" block form={OLD_VALUES_FORM_ID} htmlType="submit" type="primary">
      <FormattedMessage {...messages.next} />
    </Button>
  );
};
